import { useEffect, useState } from "react";
import { api } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import {
  Dialog, DialogContent, DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { toast } from "sonner";

export const CustomerEditDialog = ({ open, onOpenChange, customer, onUpdated }) => {
  const [form, setForm] = useState({
    first_name: "", last_name: "", phone: "", email: "",
    street: "", postal_code: "", city: ""
  });

  useEffect(() => {
    if (open && customer) {
      setForm({
        first_name: customer.first_name || "",
        last_name: customer.last_name || "",
        phone: customer.phone || "",
        email: customer.email || "",
        street: customer.street || "",
        postal_code: customer.postal_code || "",
        city: customer.city || ""
      });
    }
  }, [open, customer]);

  const handleSubmit = async () => {
    if (!customer?.id) return;
    try {
      await api.put(`/api/customers/${customer.id}`, form);
      onUpdated?.({ ...customer, ...form });
      onOpenChange(false);
      toast.success("Kundendaten aktualisiert");
    } catch {
      toast.error("Fehler beim Aktualisieren");
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg" data-testid="detail-customer-edit-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Barlow Condensed' }}>Kundendaten bearbeiten</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 mt-4">
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Vorname</Label>
              <Input value={form.first_name} onChange={(e) => setForm({ ...form, first_name: e.target.value })} placeholder="Max" />
            </div>
            <div className="space-y-2">
              <Label>Nachname</Label>
              <Input value={form.last_name} onChange={(e) => setForm({ ...form, last_name: e.target.value })} placeholder="Mustermann" />
            </div>
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>Telefon</Label>
              <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })} placeholder="+49 123 456789" />
            </div>
            <div className="space-y-2">
              <Label>E-Mail</Label>
              <Input type="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="max@beispiel.de" />
            </div>
          </div>
          <div className="space-y-2">
            <Label>Straße</Label>
            <Input value={form.street} onChange={(e) => setForm({ ...form, street: e.target.value })} placeholder="Musterstraße 1" />
          </div>
          <div className="grid grid-cols-2 gap-4">
            <div className="space-y-2">
              <Label>PLZ</Label>
              <Input value={form.postal_code} onChange={(e) => setForm({ ...form, postal_code: e.target.value })} placeholder="12345" />
            </div>
            <div className="space-y-2">
              <Label>Stadt</Label>
              <Input value={form.city} onChange={(e) => setForm({ ...form, city: e.target.value })} placeholder="Berlin" />
            </div>
          </div>
          <div className="flex justify-end gap-2 pt-4">
            <Button variant="outline" onClick={() => onOpenChange(false)}>Abbrechen</Button>
            <Button onClick={handleSubmit} data-testid="detail-customer-save-btn">Speichern</Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
